import {
  ChangeFunction,
  ApproverGroup,
  ChangeFunctionApproverGroupApprovalRequirement
} from '@domain/shifthandover'
import {useMobileBreakPoint} from '@hconnect/common/hooks/useWidth'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormControlLabel,
  Box,
  Checkbox,
  Grid,
  Typography
} from '@mui/material'
import {Dispatch, FC, SetStateAction} from 'react'

type ApproverListProps = {
  functions: ChangeFunction[]
  approverGroups: ApproverGroup[]
  data: ChangeFunctionApproverGroupApprovalRequirement[]
  onChange: Dispatch<SetStateAction<ChangeFunctionApproverGroupApprovalRequirement[]>>
}

export const ApproverList: FC<ApproverListProps> = ({
  functions,
  approverGroups,
  data,
  onChange
}) => {
  const isMobile = useMobileBreakPoint()

  return (
    <Box display="flex" overflow="auto" flexDirection="column">
      <Box flex={1} pr={0.5} data-test-id="approver-matrix-scroll-area">
        {functions.map((functionData) => (
          <Accordion
            key={functionData.id}
            defaultExpanded
            disableGutters
            data-test-id={`approver-matrix-accordion-${functionData.id}`}
            sx={{
              '&.Mui-expanded': {backgroundColor: 'transparent'}
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                px: 0,
                backgroundColor: 'transparent !important'
              }}
            >
              <Typography variant="h4">{functionData.name}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{pt: 0, px: 0, pb: 2, backgroundColor: 'transparent !important'}}>
              <Grid container spacing={1} columns={12}>
                {approverGroups.map(({id, name}) => {
                  const entry = data.find(
                    (d) => d.functionId === functionData.id && d.approverGroupId === id
                  )
                  const checked = !!entry?.approvalRequired
                  return (
                    <Grid item xs={isMobile ? 12 : 6} key={id}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checked}
                            onChange={(e) => {
                              const newChecked = e.target.checked
                              onChange((prev) =>
                                prev.map((d) =>
                                  d.functionId === functionData.id && d.approverGroupId === id
                                    ? {...d, approvalRequired: newChecked}
                                    : d
                                )
                              )
                            }}
                            size="small"
                            data-test-id={`approver-matrix-checkbox-${functionData.id}-${id}`}
                          />
                        }
                        label={name}
                        sx={{m: 0}}
                      />
                    </Grid>
                  )
                })}
              </Grid>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  )
}
